// eslint-disable-next-line import/prefer-default-export
export const features = Object.freeze({
  ccs_55_flags: 'ccs_55_flags',
})

export const specialCustomerArray = [
  'ph1200',
  'ph1331',
  'ph1324',
  'ph1325',
  'ph1326',
  'ph1327',
  'ph1328',
  'ph1329',
  'ph1364',
  'ph1410',
  'ph1544',
  'ph1530',
  'ph1670',
  'ph628',
  'ph1760',
  'ph1725',
  'ph1544x1005',
  'ph1042',
  'ph1673',
  'ph1766',
  'ph1584x201',
  'ph1584x202',
  'ph1584x203',
  'ph1584x204',
  'ph1584x205',
  'ph1584x114',
  'ph1802',
  'ph1962',
  'ph1881',
  'ph2110',
  'ph2134',
  'ph705',
  'ph2110',
  'ph1725',
  'ph2278',
  'ph1279',
  'ph2423',
  'ph2422',
  'ph2428',
  'ph2571',
  'ph2607',
]

export const version = '0.7.9.2'
